import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import SearchPage from "@/pages/SearchPage";
import SkinnyPage from "@/pages/SkinnyPage";
import ReviewWizard from "@/pages/ReviewWizard";
import ResponsePage from "@/pages/ResponsePage";
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage, VerifyPhonePage } from "@/pages/Auth";
import { TermsPage, PrivacyPage } from "@/pages/Legal";
import { FeedbackPage, ReportPage } from "@/pages/FeedbackReport";
import ContactPage from "@/pages/ContactPage";
import ZodiacPage from "@/pages/ZodiacPage";
import MyStoryPage from "@/pages/MyStoryPage";
import PurposePage from "@/pages/PurposePage";
import GoodbyePage from "@/pages/GoodbyePage";
import SharedSynastryPage from "@/pages/SharedSynastryPage";
import AuthCallback from "@/pages/AuthCallback";
import { NotificationsPage, AccountPage, MyReviewsPage } from "@/pages/UserPages";
import AdminStatsPage from "@/pages/AdminStatsPage";
import PlaylistPage from "@/pages/PlaylistPage";
import useTracker from "@/lib/useTracker";
import { PageMusic } from "@/components/welp/PageMusic";
import { AdminChangeRequest } from "@/components/welp/AdminChangeRequest";
import { ScrollToTop } from "@/components/welp/ScrollToTop";
import Seo from "@/components/welp/Seo";

function AppRouter() {
  const location = useLocation();
  useTracker();
  // Detect Google session_id in URL fragment synchronously during render
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    <ScrollToTop />
    <Seo />
    <PageMusic />
    <AdminChangeRequest />
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/profile/:pid" element={<SkinnyPage />} />
      <Route path="/review/new" element={<ReviewWizard />} />
      <Route path="/respond/:reviewId" element={<ResponsePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-phone" element={<VerifyPhonePage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/feedback" element={<FeedbackPage />} />
      <Route path="/report" element={<ReportPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/zodiac" element={<ZodiacPage />} />
      <Route path="/my-story" element={<MyStoryPage />} />
      <Route path="/purpose" element={<PurposePage />} />
      <Route path="/playlist" element={<PlaylistPage />} />
      <Route path="/goodbye" element={<GoodbyePage />} />
      <Route path="/synastry/shared/:sid" element={<SharedSynastryPage />} />
      <Route path="/notifications" element={<NotificationsPage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/account/reviews" element={<MyReviewsPage />} />
      <Route path="/admin/stats" element={<AdminStatsPage />} />
      <Route path="*" element={<Landing />} />
    </Routes>
    </>
  );
}

const TOAST_OPTIONS = { style: { background: "#FFFFFF", color: "#1A1A1A", border: "1px solid rgba(16,185,129,0.35)" } };

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster theme="light" position="top-center" toastOptions={TOAST_OPTIONS} />
      </BrowserRouter>
    </AuthProvider>
  );
}
